import { colors } from 'game/styles/theme';
import { HealthBarProps } from './HealthBarProps';

const PADDING = 5;
const PADDING_2 = PADDING * 2;
const HEIGHT = 30;
const INNER_HEIGHT = HEIGHT - PADDING_2;

export const HealthBarSprite: React.FC<HealthBarProps> = ({
  getHp,
  maxHp,
  width,
}) => {
  const hp = getHp();
  if (hp === maxHp || hp <= 0) return null;
  const x = -width / 2;
  const xInner = x + PADDING;
  const widthInner = width - PADDING_2;

  return (
    <>
      <rect width={width} x={x} height={HEIGHT} fill="white" strokeWidth={4} stroke="black" />
      <rect width={widthInner} x={xInner} y={PADDING} height={INNER_HEIGHT} fill={colors.grey5} />
      <rect
        width={(hp / maxHp) * widthInner}
        height={INNER_HEIGHT}
        x={xInner}
        y={PADDING}
        fill={colors.accent}
      />
    </>
  );
};
